var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 8,
  viewBox: "0 0 16 8"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Polygon_46",
  "data-name": "Polygon 46",
  transform: "translate(16 8) rotate(180)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8,0l8,8H0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 7.999999523162842 1.414219856262207 L 2.414219856262207 7 L 13.58577919006348 7 L 7.999999523162842 1.414219856262207 M 7.999999523162842 0 L 16 8 L -9.5367431640625e-07 8 L 7.999999523162842 0 Z",
  stroke: "none",
  fill: "#fff"
}))));
export default __webpack_public_path__ + "static/media/downArrow.5a2c59a5.svg";
export { SvgComponent as ReactComponent };